export const SPACE = { xs: 4, sm: 8, md: 16, lg: 24, xl: 32 };

export const RADIUS = 8;

export const TEXT = {
  primary: '#1a1d29',
  secondary: '#5b6478',
  tertiary: '#9aa1b1',
};

export const SURFACE = {
  border: '#e5e7eb',
  divider: '#eef0f4',
  hover: '#f7f8fa',
};

export const cardSx = {
  borderRadius: `${RADIUS}px`,
  border: `1px solid ${SURFACE.border}`,
};

export const pageSx = {
  maxWidth: '100%',
  margin: '0 auto',
  padding: '0 5px 0 10px'
};
